import { memo, useMemo } from 'react';
import { t } from 'i18next';

import {
  AstroBreadcrumb as Breadcrumb,
  breadcrumbArray,
} from '@/components/ui/custom/AstroBreadcrumb';
import { ROUTES } from '@/utils/routes';

type CourseStudioBreadcrumbProps = {
  courseName?: string;
  loading?: boolean;
};

function CourseStudioBreadcrumb(props: CourseStudioBreadcrumbProps) {
  const { courseName: name = '', loading } = props;

  const breadcrumbPaths = useMemo(() => {
    const courseRoute = ROUTES.ADMIN.COURSES.BASE;

    const paths: breadcrumbArray[] = [
      { url: '/', name: 'Home', routeType: 'home' },
      { url: courseRoute, name: t('common.courses'), routeType: 'courses' },
    ];

    if (name) {
      paths.push({
        name,
        url: courseRoute,
        routeType: 'courses',
        loading,
      });
    }

    return paths;
  }, [name, loading]);

  return <Breadcrumb breadcrumbList={breadcrumbPaths} className="min-h-5" />;
}

export default memo(CourseStudioBreadcrumb);
